import { defineStyleConfig } from "@chakra-ui/react";

const Card = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    container: {
      background: "secondary.600",
      borderRadius: "xl",
    },
    body: {
      overflow: "auto",
    },
  },
});

export default Card;
